import React from "react";
import TrainJourneyEdit from "../components/TrainJourneyEdit";
import SegmentEdit from "../components/SegmentEdit";
import { Button } from "semantic-ui-react";
import { defaultSegment, defaultTrain, trainDetailsToInstruction } from "../utils";

interface Props {
  initialTrain: server.dto.Train
  onFinished: (train: server.dto.Train) => void
  setOnSegmentAddedHandler: (callback: () => void) => void
  fromItem: server.dto.FromItem
  initialDate: Date
}
const getNewSegment = (initialStartDate: Date) => {
  const newSegment = defaultSegment();
  newSegment.startLocal = initialStartDate || new Date();
  newSegment.endLocal = initialStartDate || new Date();
  return newSegment;
};

const NewTrainJourneyEditScreen = (props: Props) => {
  const [train, setTrain] = React.useState(props.initialTrain ? trainDetailsToInstruction(props.initialTrain) : defaultTrain());
  const [segments, setSegments] = React.useState([getNewSegment(props.initialDate)]);
  const [artistError, setArtistError] = React.useState<boolean>(false);
  const [travellersError, setTravellerError] = React.useState<boolean>(false);

  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [attemptedSave, setAttemptedSave] = React.useState(false);

  const onSave = async (e) => {
    e.preventDefault();
    setAttemptedSave(true);
    if (artistError || isLoading) {
      console.log("Is loading: " + isLoading, "artistError: " + artistError);
      return;
    }

    const hasNoArtist = train.artistId == null;
    const hasNoTravellers = train.travellerIds.length === 0;

    if (hasNoArtist) {
      console.log("has no artist:", hasNoArtist);
      setArtistError(true);
      return;
    }

    if (hasNoTravellers) {
      console.log("has no travellers", hasNoTravellers);
      setTravellerError(true);
      return;
    }

    const noEmptyStations = segments.every(seg => seg.startStationId != null && seg.endStationId != null);
    if (!noEmptyStations) {
      console.log("there are empty stations", segments);
      return;
    }

    setIsLoading(true);
    console.log("passed all checks, starting to load");

    const payload: server.dto.CreateTrainInstruction = {
      details: train,
      segments
    };

    const result = await window.Api.Trains.CreateTrain(payload);
    console.log("Got response from server: ", result);
    if (props.fromItem?.type === "show" && result.data.segments.length > 0) {
      for (const seg of result.data.segments) {
        await window.Api.Shows.LinkTrainSegment(props.fromItem.id, seg.id);
      }
    }
    props.onFinished(result.data);
  };

  const onTrainChange = (newTrain: server.dto.ModifyTrainDetailsInstruction) => {
    if (newTrain.travellerIds.length > 0) {
      setTravellerError(false);
    }
    if (newTrain.artistId != null) {
      setArtistError(false);
    }

    setTrain(newTrain);
  };

  const onSegmentEdit = (newSegment: server.dto.ModifyTrainSegmentInstruction, index: number) => {
    const newSegments = Object.assign([], segments, { [index]: newSegment });

    setSegments(newSegments);
  };

  const addNewSegment = () => {
    const newSegments = [...segments, getNewSegment(props.initialDate)];

    setSegments(newSegments);
  };

  React.useEffect(() => {
    props.setOnSegmentAddedHandler(addNewSegment);
  }, [segments]);

  return <>
    <div className="grow1 scrollbox-auto s1_panel">
      <TrainJourneyEdit
        train={train}
        onTrainChanged={onTrainChange}
        noArtistError={artistError}
        travellersError={travellersError}

        initialArtist={props.initialTrain?.artist}
        initialTravellers={props.initialTrain?.travellers}
        initialPhase={props.initialTrain?.phase}
      />

      {segments.map((seg, idx) => (
        <SegmentEdit
          key={seg.key}
          segment={seg}
          onSegmentChange={segment => { onSegmentEdit(segment, idx); }}
          startStationEmpty={attemptedSave && seg.startStationId == null}
          endStationEmpty={attemptedSave && seg.endStationId == null}
        />
      ))}
    </div>

    <div className="flex margin-top-large justify-end margin-right">
      <div>
        <Button loading={isLoading} primary onClick={onSave}>{RESX.Buttons.btnSave}</Button>
      </div>
    </div>
  </>;
};

export default NewTrainJourneyEditScreen;